import { quickOrderProductListStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(quickOrderProductListStyles, {
    quantityGridItem: {
        // width: [12, 6, 9, 9, 9],
        width: [12, 6, 5, 4, 3],
        printWidth: 6,
        css: css`
            & div {
                margin-top: 0px;
                flex-direction: row;
                align-items: center;
                border-radius: 8px;
                background-color: #e1e7ed;
                color: ${COLORS.lightBlack};
                label {
                    text-align: center;
                    padding: 8px;
                    width: 54%;
                    @media (max-width: 1199px) and (min-width: 200px) {
                        font-size: 13px !important;
                    }
                }
                & > div {
                    margin-top: 0 !important;
                    width: 100%;
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                    }
                    input {
                        border-radius: 0 8px 8px 0 !important;
                    }
                }
            }
        `,
    },
    availability: {
        container: {
            css: css`
                margin-top: 10px;
                & > div {
                    & > :nth-child(2) {
                        justify-content: flex-end;
                    }
                }
            `,
        },
    },
    removeProductGridItem: {
        css: css`
            text-align: center;
            display: block;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 15px 0;
                        `,
                    ],
                    "max",
                )}
        `,
        width: [3, 3, 3, 2, 2],
    },
    productInfoGridItem: {
        width: [7, 7, 7, 8, 8],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            padding: 10px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    brandAndProductDescriptionGridItem: {
        width: [12, 12, 12, 4, 5],
        css: css`
            flex-direction: column;
        `,
    },
    priceAndQuantityGridItem: { width: [12, 12, 12, 8, 7] },
    price: {
        price: {
            priceText: {
                css: css`
                    color: #1e75ba;
                `,
            },
        },
    },
});
